import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface ChannelListChargePointIdentityCellProps
  extends CellContext<
    GatewayChannelWithChargePointInfoModel,
    GatewayChannelWithChargePointInfoModel['chargePointIdentity']
  > {}

export const ChannelListChargePointIdentityCell = (
  props: ChannelListChargePointIdentityCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() => {
        const path = generatePath(APP_PATH.CHARGE_POINT.DETAILS, {
          id: row.original.chargePointId,
        });
        navigate(`${path}?tab=channels-tab&channelId=${row.original.id}`);
      }}
      fullWidth>
      <Text truncate>{getValue()}</Text>
    </Link>
  );
};
